// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OrchMedicalCardFinderResponseModel } from './orchMedicalCardFinderResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EntlibResponseOrchMedicalCardFinderResponseModel {
    'data': OrchMedicalCardFinderResponseModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EntlibResponseOrchMedicalCardFinderResponseModel>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "OrchMedicalCardFinderResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return EntlibResponseOrchMedicalCardFinderResponseModel.attributeTypeMap;
    }
}
